
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 24a.753.753 0 01-.726-.94l1.82-6.94a.405.405 0 01.015-.046.5.5 0 01.02-.058.85.85 0 01.053-.096.829.829 0 01.084-.113l.025-.028L16.529 1.294A4.347 4.347 0 0119.62.007a4.36 4.36 0 013.101 1.275l.019.019a4.377 4.377 0 01-.059 6.205L8.223 21.961a.633.633 0 01-.069.057.714.714 0 01-.271.139L.941 23.976A.812.812 0 01.75 24zm1.051-1.801l4.864-1.274-1.076-2.511-2.514-1.073-1.274 4.858zm6.149-2.086L18.594 9.471l-1.501-1.5L7.05 18.012l.9 2.101zm-1.962-3.16L16.032 6.911l-1.5-1.499L3.886 16.055l2.102.898zm13.667-8.542l1.028-1.027-4.062-4.06-1.028 1.028 4.062 4.059zm2.087-2.09c.483-.526.75-1.199.758-1.913a2.86 2.86 0 00-.819-2.045l-.017-.018a2.865 2.865 0 00-2.032-.839l-.008-.375.001.375c-.726.002-1.41.27-1.94.758l4.057 4.057z"}})])
          )
        }
      }
    